import { createPinia } from "pinia";

import { createApp } from "vue";

import { i18n, loadLocaleMessages } from "@/shared/locales/i18n";
import router from "@/shared/router";

import App from "./App.vue";
import "./main.css";

async function init() {
    await loadLocaleMessages("no");
    const app = createApp(App);

    app.use(createPinia());
    app.use(router);
    app.use(i18n);

    app.mount("#app");
}

init();
